import React, { ReactNode } from 'react'
import classNames from 'classnames'
import styles from './Alert.module.css'

export default function Alert({
  children,
  className,
  severity
}: {
  children: ReactNode
  className?: string
  severity: 'error' | 'info' | 'success' | 'warning'
}) {
  const classes = classNames({
    [styles.alert]: true,
    [styles[severity]]: true,
    [`${className}`]: true
  })

  return <div className={classes}>{children}</div>
}
